import Database from 'better-sqlite3';
import type { Logger } from 'pino';

import { FILES_SCHEMA, SNAPSHOTS_SCHEMA } from './Schema';

function safeAlter(db: Database.Database, sql: string): void {
  try {
    db.exec(sql);
  } catch (error: any) {
    if (
      typeof error?.message === 'string' &&
      error.message.includes('duplicate column name')
    ) {
      return;
    }
    throw error;
  }
}

function applyMigrations(db: Database.Database, logger: Logger): void {
  const alterations = [
    'ALTER TABLE files ADD COLUMN hash_owner TEXT',
    'ALTER TABLE files ADD COLUMN hash_lease_expires_at INTEGER',
    'ALTER TABLE files ADD COLUMN hash_started_at INTEGER',
  ];
  for (const sql of alterations) {
    try {
      safeAlter(db, sql);
    } catch (error) {
      logger.error({ err: error, sql }, 'Database migration failed');
      throw error;
    }
  }

  db.exec(
    'CREATE INDEX IF NOT EXISTS idx_files_hash_lease ON files(hash_state, hash_lease_expires_at)',
  );
}

export function openDatabase(
  dbPath: string,
  logger: Logger,
): Database.Database {
  const db = new Database(dbPath, { verbose: undefined });
  logger.info({ dbPath }, 'Opened SQLite database');

  db.pragma('journal_mode = WAL');
  db.pragma('synchronous = NORMAL');
  db.pragma('busy_timeout = 5000');
  db.pragma('foreign_keys = ON');

  db.exec('BEGIN');
  try {
    db.exec(FILES_SCHEMA);
    db.exec(SNAPSHOTS_SCHEMA);
    db.exec('COMMIT');
  } catch (error) {
    db.exec('ROLLBACK');
    db.close();
    throw error;
  }

  applyMigrations(db, logger);

  return db;
}
